import { MapPin } from "lucide-react";

export function CityCard({ city, href, index }) {
  return (
    <a className="city-card" href={href} data-testid={`city-card-link-${index}`}>
      <MapPin size={18} aria-hidden="true" />
      <span data-testid={`city-card-title-${index}`}>{city}</span>
      <small data-testid={`city-card-meta-${index}`}>Página SEO física</small>
    </a>
  );
}